<template>
  <main>
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back.svg" onclick="history.back()" class="back" />
      </h1>
      <div class="writer">
        <div v-if="myPhotoUrl == ''" class="profile_pic" style="background-image: url(images/basic/img/default.svg)"></div>
        <div v-else class="profile_pic" :style="`background-image: url(${myPhotoUrl});`"></div>
        <div class="user">
          <span style="display: none">Lv.1 </span>
          <span>{{ $store.state.userInfo.name }}</span>
          <!-- <p><select name="" id=""><option value="">전체공개</option><option value="">파티공개</option><option value="">비공개</option></select></p> -->
        </div>
        <!--<a href="javascript:chk_form();" class="submit">작성완료</a>-->

        <a @click="writePost" class="submit">작성완료</a>
      </div>
    </div>

    <div class="view_wrapper write_wrapper">
      <div class="div_padding"></div>
      <div class="content write-form">
        <form name="frm" method="post" action="/community_write" enctype="multipart/form-data">
          <select class="board_sel" name="boardId" v-model="boardId">
            <option v-for="menu in resultList" :key="menu.boardId" :value="menu.boardId" @focus="changeBoardId(menu.boardId)">{{ menu.boardNm }}</option>
          </select>

          <!-- file list -->
          <div id="file_list">
            <div v-for="file in fileList" :key="file.name">
              <template v-if="file.type != 'image'">
                <div class="attached">
                  <a href="javascript:void(0)" class="file-name" v-html="file.name"></a>
                  <a href="javascript:void(0)" @click="deleteFile(file)"><img src="images/basic/icon/trash-b.svg" alt="" /></a>
                </div>
              </template>
            </div>
          </div>
          <div class="caution" v-if="boardId == 'BOARD_00000000000002'">
            <h5>
              홍보글은 홍보란에 등록해주세요.<br />
              글 내용중 아래 내용이 포함된 경우 영구 정지될수 있습니다
            </h5>
            <ol>
              <li>추천인 (초대코드, 초대주소, 초대링크, 가입링크) 관련 정보</li>
              <li>스마트컨트랙트 정보</li>
              <li>홍보사이트 정보</li>
            </ol>
          </div>
          <textarea name="nttCn" rows="8" id="nttCn" v-model="nttCn" ></textarea>
          <div id="file_list">
            <div v-for="file in fileList" :key="file.name">
              <template v-if="file.type == 'image'">
                <div style="padding-top: 5px">
                  <div class="img_box" @click="file.isActive = !file.isActive">
                    <img :src="file.url" alt="" srcset="" style="width: 100%; height: auto;">
                    <div class="del_box" :class="{ on: file.isActive }">
                      <div class="btn_box" @click.prevent="deleteFile(file)">
                        <img src="/images/basic/icon/icon-del-photo.svg" alt="">
                        <p>삭제</p>
                      </div>
                    </div>
                  </div>
                </div>  
              </template>
            </div>
          </div>

          <div class="chat_option">
            <div class="" id="btn_camera">
              <label for="cameraFileInput">
                <i class="fas fa-camera"></i>
                <input id="cameraFileInput" type="file" accept="image/*" capture="environment" name="camera_file" style="display: none" ref="camera" @change="cameraInputChange($event)" @click="clearInput($event)"/>
              </label>
            </div>
            <div class="album">
              <label for="albumFileInput">
                <i class="fas fa-image"></i>
                <input id="albumFileInput" type="file" accept="image/*" name="album_file" style="display: none" @change="albumInputChange($event)" @click="clearInput($event)"/>
              </label>
            </div>
            <div class="attach">
              <label for="allFileInput">
                <i class="fas fa-link"></i>
                <input id="allFileInput" type="file" name="all_file" style="display: none" @change="allInputChange($event)" @click="clearInput($event)" />
              </label>
            </div>
          </div>
          
        </form>
      </div>
    </div>
    <div class="overlay">
        <div class="spinner center">
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
          <div class="spinner-blade"></div>
        </div>
      </div>
  </main>
</template>

<script>
import { fetchWriteCommunityTabList, insertBoard } from "@/api/boards";
export default {
  created() {
    if (this.$route.query.boardId !== "BOARD_00000000000001" && this.$route.query.boardId !== "BOARD_00000000000005") {
      this.boardId = this.$route.query.boardId;
    }
    this.fetchBoardList();
  },
  mounted() {
    window.$(document).ready(function () {
      window.$("textarea").focus();
      //document.body.ontouchend = function() { window.$("textarea").focus(); };

    });


  
    /**
     * under line is call input value change
     * cameraInputChange() = native camera complete call
     * albumInputChange()  = native album complete call
     * allInputChange()    = native all file complete call
     *
     */
  },
  data() {
    return {
      resultList: [],
      fileArray: [],
      fileList: [],
      nttCn: "",
      boardId: "",
      writeRequested: false,
    };
  },
  computed: {
    myPhotoUrl() {
      return this.$store.state.userInfo.myPhotoUrl;
    },
  },
  methods: {
    async fetchBoardList() {
      try {
        const result = await fetchWriteCommunityTabList();
        this.resultList = result.data.resultList;
      } catch (error) {
        console.log(error);
      }
    },
    updateFileList() {
      this.fileList = this.fileArray;
    },
    deleteFile(file) {
      const idx = this.fileArray.findIndex((i) => i.name == file.name);
      this.fileArray.splice(idx, 1);
      this.fileList = this.fileArray;
    },
    writePost() {
      let boardId = this.boardId;
      let nttCn = this.nttCn;
      if (nttCn == undefined || nttCn.trim() == "") {
        alert("게시글의 내용을 작성해 주세요.");
        return;
      }
      if(nttCn.trim().length < 10){
        alert("게시글의 내용을 10자 이상 작성해 주세요.");
        return;
      }

      if (this.boardId == "" || this.boardId == undefined) {
        alert("카테고리를 선택해 주세요.");
        return;
      }

      var target = this.resultList.find(m => m.boardId == this.boardId);
      if(target == undefined){
        alert("카테고리를 선택해 주세요.");
        return;
      }

      if(target.writeFus > 0){
        var confirm_val = confirm("해당카테고리는\n글작성시에 " +target.writeFus +"FUS가 차감됩니다.");
        if(!confirm_val){
          return
        }
      }

      if(this.writeRequested) return;
      this.writeRequested = true;
      
      var frm = new FormData();
      frm.append("boardId", boardId);
      frm.append("nttCn", nttCn);
      for (let i = 0; i < this.fileArray.length; i++) {
        var fileObj = this.fileArray[i];
        frm.append("file" + i, fileObj.file);
      }

      window.$(".overlay").addClass("on");

      insertBoard(frm)
        .then((response) => {
          console.log(response)
          this.writeRequested = false;
          // 응답 처리
          window.$(".overlay").removeClass("on");
          if(response.data.resultCode == "1000"){
            this.$router.push("/community");
          }else{
            alert("게시물 등록에 실패했습니다.");
          }
        })
        .catch((error) => {
          window.$(".overlay").removeClass("on");
          this.writeRequested = false;
          console.log(error);
          // 예외 처리
        });
    },
    clearInput(e){
      e.target.value = ''
    },
    cameraInputChange(e) {
      this.pushFile(e);
    },
    albumInputChange(e) {
      this.pushFile(e);
    },
    allInputChange(e) {
      this.pushFile(e);
    },
    pushFile(e) {
      var file = e.target.files[0];
      var fileObj = new Object();
      var fileType = "etc";
      if(file.type.includes("image")){
        fileType = "image";
        fileObj.url = window.URL.createObjectURL(file);
      }
      fileObj.index = this.fileArray.length;
      fileObj.name = file.name;
      fileObj.file = file;
      fileObj.type = fileType;
      fileObj.isActive = false;
      this.fileArray.push(fileObj);
      this.updateFileList();
    },
  },
  destroyed() {
    this.$store.commit("udtBoardId", this.$route.query.boardId);
  },
};
</script>

<style>
  .img_box {position:relative;}
  .img_box .del_box.on {display:block;}
  .img_box .del_box {display:none;position:absolute; width:100%; height:100%; background-color:rgba(0,0,0,0.8); top:0; left:0;}
  .img_box .del_box .btn_box {position:absolute; top:calc(50% - 23px); left:calc(50% - 13px); text-align: center;}
  .img_box .del_box .btn_box img {max-width:26px;}
  .img_box .del_box .btn_box p {color:#fff; font-size:14px;}

</style>
